import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { error } from 'protractor';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationItem } from 'src/app/shared/models/NotificationItem';
import { LayoutService } from '../../../../../core';
import {
  Notification,
  NotificationType,
} from '../../../../../../shared/models/Notification';
import { Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { RegistroAlerta } from 'src/app/models/Alertas/RegistroAlerta';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { TokenStorageService } from "src/app/services/token-storage.service";
import { SessionUser } from "src/app/shared/models/sessionUser";

@Component({
  selector: 'app-notifications-dropdown-inner',
  templateUrl: './notifications-dropdown-inner.component.html',
  styleUrls: ['./notifications-dropdown-inner.component.scss'],
})
export class NotificationsDropdownInnerComponent implements OnInit {
  extrasNotificationsDropdownStyle: 'light' | 'dark' = 'dark';
  newNotificationsCount: number = 2;
  activeTabId:
    | 'topbar_notifications_notifications'
    | 'topbar_notifications_events'
    | 'topbar_notifications_logs' = 'topbar_notifications_notifications';

  notificationsList: Notification[] = [];
  notificationItems: NotificationItem[] = [];
  subcriptions;
  public usuarioId: string;
  public waitingAlerts$: Observable<boolean>;
  private alertListObs$: Observable<RegistroAlerta[]>;
  public alertList: RegistroAlerta[] = [];
  public unreadAlerts: boolean = false;
  public isMarkingAllAsRead: boolean = false;
  public waitForReadRequestAlert$: Observable<boolean>;
  constructor(
    private layout: LayoutService,
    private notificationService: NotificationService,
    private ref: ChangeDetectorRef,
    private tokenService: TokenStorageService,
    private localStorage: LocalStorageService
  ) {
    this.waitingAlerts$ = this.notificationService.isLoadingAlerts;
    this.alertListObs$ = this.notificationService.alertListObservable;
    this.waitForReadRequestAlert$ =
    this.notificationService.isloadingReadAlertRequest;
    this.usuarioId = (this.tokenService.getUser() as SessionUser).id;
  }

  ngOnInit(): void {
    this.extrasNotificationsDropdownStyle = this.layout.getProp(
      'extras.notifications.dropdown.style'
    );
    //this.notificationService.notificationsInterval.subscribe();
    this.subcriptions = this.notificationService.multiNotifications.subscribe(
      (res) => {
        //this.notificationService.directAlertRefresh();
        switch (res.type) {
          case NotificationType.Informacion:
            this.newInfoNotificationItem(res);
            this.ref.detectChanges();
            break;
          case NotificationType.Peligro:
            this.newErrorNotificationItem(res);
            this.ref.detectChanges();
            break;
          case NotificationType.Advertencia:
            this.newWarningNotificationItem(res);
            this.ref.detectChanges();
            break;
          default:
            //this.newInfoNotificationItem(res);
            break;
        }
      },
      (error) => {
      }
    );

    this.alertListObs$.subscribe((list) => {
      if (list && list.length > 0) {
        list.forEach((alert) => this.formatDateForShowing(alert));
        this.alertList = list;
        this.activeTabId = 'topbar_notifications_events'
        this.unreadAlerts = this.checkForUnreadAlerts();
      } else {
        this.alertList = [];
      }
    });
  }

  setActiveTabId(tabId) {
    this.activeTabId = tabId;
  }

  getActiveCSSClasses(tabId) {
    if (tabId !== this.activeTabId) {
      return '';
    }
    return 'active show';
  }

  newInfoNotificationItem(notificationRef: Notification) {
    let newItem = new NotificationItem(
      notificationRef.type,
      notificationRef.title,
      notificationRef.message,
      notificationRef.link
    );
    newItem.itemSvg = 'assets/media/svg/icons/Home/Library.svg';
    newItem.itemIconClass = 'svg-icon-primary';
    newItem.itemSymbolClass = 'symbol-light-primary';
    this.notificationItems.unshift(newItem);
  }
  newErrorNotificationItem(notificationRef: Notification) {
    let newItem = new NotificationItem(
      notificationRef.type,
      notificationRef.title,
      notificationRef.message,
      notificationRef.link
    );
    newItem.itemSvg = 'assets/media/svg/icons/General/Attachment2.svg';
    newItem.itemIconClass = 'svg-icon-danger';
    newItem.itemSymbolClass = 'symbol-light-danger';
    //this.notificationItems.unshift(newItem);
  }
  newWarningNotificationItem(notificationRef: Notification) {
    let newItem = new NotificationItem(
      notificationRef.type,
      notificationRef.title,
      notificationRef.message,
      notificationRef.link
    );
    newItem.itemSvg = 'assets/media/svg/icons/General/Attachment2.svg';
    newItem.itemIconClass = 'svg-icon-warning';
    newItem.itemSymbolClass = 'symbol-light-warning';
    this.notificationItems.unshift(newItem);
  }

  ngOnDestroy() {
    this.subcriptions.unsubscribe();
  }
  markAsSeen(alerta: RegistroAlerta, index) {
    this.formatDateForShowing(alerta);
    alerta.pidiendoLectura = true;
    this.notificationService.readAlertRequest(alerta).subscribe(
      (result) => {
        alerta.leida = true;
        alerta.pidiendoLectura = false;
        this.alertList.splice(index, 1);
        this.notificationService.directAlertRefresh();
        this.localStorage.updateAlertas(alerta);
        this.unreadAlerts = this.checkForUnreadAlerts();
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error en Alerta',
          text: 'El estado de la alerta no ha podido ser actualizado',
        });
      }
    );
  }

  markAllAsSeen(): void {
    this.isMarkingAllAsRead = true;  
    this.notificationService
      .markAllAlertsAsRead(this.usuarioId)
      .subscribe(
        (result) => {
          if (result.data) {
            this.alertList = this.alertList.map((alert) => {
              if (alert.usuarioId === this.usuarioId) {
                alert.leida = true;
                alert.pidiendoLectura = false;
                this.localStorage.updateAlertas(alert);
                this.notificationService.directAlertRefresh();
              }
              return alert;
            });
          }
          this.isMarkingAllAsRead = false;
          this.ref.detectChanges();
        },
        (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo marcar todas las alertas como leídas.',
          });
          this.isMarkingAllAsRead = false;
          this.ref.detectChanges();
        }
      );
  }
  

  formatDateForShowing(alerta: RegistroAlerta) {
    let today = moment();
    let todayString = today.format('L');
    let alertaDayString = moment(alerta.fechaCreacion).format('L');
    if (today.isSame(moment(alerta.fechaCreacion), 'd')) {
      alerta.dateToShow =
        'Emitido a las ' + moment(alerta.fechaCreacion).format('HH:mm:ss');
    } else {
      let days = moment(todayString, 'DD/MM/YYYY').diff(
        moment(alertaDayString, 'DD/MM/YYYY'),
        'days'
      );
      if (days > 1) {
        alerta.dateToShow = 'Emitido hace ' + days + ' dias';
      } else {
        alerta.dateToShow = 'Emitido ayer';
      }
    }
    this.ref.detectChanges();
  }

  checkForUnreadAlerts(): boolean {
    if (this.alertList && this.alertList.length > 0) {
      return this.alertList.some((alert) => !alert.leida);
    } else {
      return false;
    }
  }
}
